export default {
    root: {
        class: [
            // Flex & Alignment
            "flex items-center justify-center flex-wrap",

            // Spacing
            "px-4 py-2",

            // Shape
            "border-0",

            // Color
            "bg-stone-50 dark:bg-stone-800",
            "text-stone-500 dark:text-white/60",
        ],
    },
    first: ({ context }) => ({
        class: [
            "relative",

            // Flex & Alignment
            "inline-flex items-center justify-center",

            // Shape
            "border-0 rounded-full dark:rounded-md",

            // Size
            "min-w-[3rem] h-12 m-[0.143rem]",
            "leading-none",

            // Color
            "text-stone-500 dark:text-white/60",

            // State
            {
                "hover:bg-stone-100 dark:hover:bg-stone-700/70":
                    !context.disabled,
                "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-400/50 dark:focus:ring-askr-green-300/50":
                    !context.disabled,
            },

            // Transition
            "transition duration-200",

            // Misc
            "user-none overflow-hidden",
            {
                "cursor-default pointer-events-none opacity-60":
                    context.disabled,
            },
        ],
    }),
    prev: ({ context }) => ({
        class: [
            "relative",

            // Flex & Alignment
            "inline-flex items-center justify-center",

            // Shape
            "border-0 rounded-full dark:rounded-md",

            // Size
            "min-w-[3rem] h-12 m-[0.143rem]",
            "leading-none",

            // Color
            "text-stone-500 dark:text-white/60",

            // State
            {
                "hover:bg-stone-100 dark:hover:bg-stone-700/70":
                    !context.disabled,
                "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-400/50 dark:focus:ring-askr-green-300/50":
                    !context.disabled,
            },

            // Transition
            "transition duration-200",

            // Misc
            "user-none overflow-hidden",
            {
                "cursor-default pointer-events-none opacity-60":
                    context.disabled,
            },
        ],
    }),
    next: ({ context }) => ({
        class: [
            "relative",

            // Flex & Alignment
            "inline-flex items-center justify-center",

            // Shape
            "border-0 rounded-full dark:rounded-md",

            // Size
            "min-w-[3rem] h-12 m-[0.143rem]",
            "leading-none",

            // Color
            "text-stone-500 dark:text-white/60",

            // State
            {
                "hover:bg-stone-100 dark:hover:bg-stone-700/70":
                    !context.disabled,
                "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-400/50 dark:focus:ring-askr-green-300/50":
                    !context.disabled,
            },

            // Transition
            "transition duration-200",

            // Misc
            "user-none overflow-hidden",
            {
                "cursor-default pointer-events-none opacity-60":
                    context.disabled,
            },
        ],
    }),
    last: ({ context }) => ({
        class: [
            "relative",

            // Flex & Alignment
            "inline-flex items-center justify-center",

            // Shape
            "border-0 rounded-full dark:rounded-md",

            // Size
            "min-w-[3rem] h-12 m-[0.143rem]",
            "leading-none",

            // Color
            "text-stone-500 dark:text-white/60",

            // State
            {
                "hover:bg-stone-100 dark:hover:bg-stone-700/70":
                    !context.disabled,
                "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-400/50 dark:focus:ring-askr-green-300/50":
                    !context.disabled,
            },

            // Transition
            "transition duration-200",

            // Misc
            "user-none overflow-hidden",
            {
                "cursor-default pointer-events-none opacity-60":
                    context.disabled,
            },
        ],
    }),
    page: ({ context }) => ({
        class: [
            "relative",

            // Flex & Alignment
            "inline-flex items-center justify-center",

            // Shape
            "border-0 rounded-full dark:rounded-md",

            // Size
            "min-w-[3rem] h-12 m-[0.143rem]",
            "leading-none",

            // Color
            "",
            {
                "bg-askr-green text-white ": context.active,
                "text-stone-500 dark:text-white/80": !context.active,
            },

            // State
            {
                "hover:bg-stone-100 dark:hover:bg-stone-700/70":
                    !context.disabled && !context.active,
                "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-400/50 dark:focus:ring-askr-green-300/50":
                    !context.disabled,
            },

            // Transition
            "transition duration-200",

            // Misc
            "user-none overflow-hidden",
            {
                "cursor-default pointer-events-none opacity-60":
                    context.disabled,
            },
        ],
    }),
    contentStart: "mr-auto",
    contentEnd: "ml-auto",
    content: () => ({
        class: ["flex items-center gap-2"],
    }),
    pcRowPerPageDropdown: ({ context }) => ({
        root: () => ({
            class: [
                "order-last inline-flex relative rounded-md bg-stone-50 dark:bg-stone-900 border dark:border-stone-700 border-stone-300 dark:border-stone-600 invalid:focus:ring-red-200 invalid:hover:border-red-500 transition-all duration-200 hover:border-askr-green cursor-pointer select-none",
            ],
        }),
    }),
};
